import React from 'react';

interface IProps {
	children: React.ReactNode;
}

export const FormColumn: React.FC<IProps> = ({ children }) => <div className="flex flex-col gap-4">{children}</div>;
